import api from '@/api/axiosConfig.js';

const BASE_PATH = '/api/flota/asignaciones';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.append(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

function getResponseData(response, fallback = null) {
  if (!response?.data?.ok) {
    const errorMessage = response?.data?.error || response?.data?.message || 'Respuesta inválida del servidor.';
    throw new Error(errorMessage);
  }
  return response.data.data ?? fallback;
}

function buildServiceError(error, fallbackMessage) {
  const apiMessage = error?.response?.data?.error
    || error?.response?.data?.message
    || error?.response?.data?.details
    || error?.message
    || fallbackMessage;
  const isServerError = Number(error?.response?.status) >= 500;
  const nextError = new Error(isServerError ? fallbackMessage : apiMessage);
  nextError.status = error?.response?.status || null;
  nextError.field = error?.response?.data?.field || null;
  nextError.code = error?.response?.data?.code || error?.code || null;
  nextError.details = error?.response?.data?.details || null;
  nextError.payload = error?.response?.data || null;
  return nextError;
}

export async function fetchAsignaciones(filters = {}) {
  const response = await api.get(`${BASE_PATH}${buildQuery(filters)}`);
  return getResponseData(response, []);
}

export async function fetchAsignacionesOpciones() {
  const response = await api.get(`${BASE_PATH}/opciones`);
  return getResponseData(response, { choferes: [], vehiculos: [] });
}

export async function createAsignacion(payload) {
  try {
    const response = await api.post(BASE_PATH, payload);
    return getResponseData(response, null);
  } catch (error) {
    throw buildServiceError(error, 'No pudimos asignar el chofer.');
  }
}

export async function finalizarAsignacion(id, payload = {}) {
  const response = await api.patch(`${BASE_PATH}/${id}/cerrar`, payload);
  return getResponseData(response, null);
}
